// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list","962":"home"}[chunkId] || chunkId) + "-" + {"137":"8f1952ff70d3f8ea3634","702":"70038211a652d1f87b98","715":"2a621a78a3b1d5d660c1","962":"a8085a49c2588b43dc30"}[chunkId] + ".css";
};